import images from "@/assets/images";

interface ILiveAppProps {}
const LiveApp: React.FC<ILiveAppProps> = () => {
  return (
    <div className="mx-[28px] flex h-full max-h-full flex-col items-center overflow-y-auto pb-[30px] pt-[106px]">
      <img src={images.AppLive} className="mb-[13px] w-full" id="live-app-product-image" />
      <p className="mb-[8px] text-[16px] leading-[22px] text-[#fff]">虎牙直播主播端</p>
      <p className="mb-[20px] text-[32px] leading-[45px] text-[#fff]">功能强大，快速上手</p>
      <p className="mb-[64px] whitespace-break-spaces text-center text-[14px] leading-[22px] text-[#FFFFFF99]">
        {
          "虎牙直播主播端具有强大的开播功能支持\n多样的开播玩法选择，有效帮助你提高直播内容\n质量，创造更多有趣的直播效果！"
        }
      </p>
      <p className="mb-[4px] text-[14px] leading-[20px] text-[#FFFFFF99]">请在电脑访问操作</p>
      <p className="text-[14px] leading-[22px] text-[#FFFFFF99]">https://hd.huya.com/download/</p>
    </div>
  );
};

export default LiveApp;
